import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the Packages grid. Mirrors PackageCard:
//   icon · title (italic serif, large) · param/tat subline · price row
//   (big price + strikethrough + save% pill) · clock/time row · 2 bullets
//   · CTA button.
// 1/2/3/4 column responsive grid matches the real page.

const PackageCardShimmer = () => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1.5px solid var(--border-l)',
      borderRadius: '20px',
      p: { xs: 2.25, md: 2.75 },
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    }}
  >
    {/* Optional "Most Booked" ribbon placeholder — renders even on
        non-featured cards since we don't know which are featured yet.
        Kept narrow + subtle so the row isn't crowded. */}
    <Shimmer
      width={88}
      height={20}
      rounded={100}
      sx={{ position: 'absolute', top: 12, right: 12 }}
    />

    {/* Icon */}
    <Shimmer width={36} height={36} rounded={6} sx={{ mb: 1.5 }} />

    {/* Title (2 lines — serif italic is big) */}
    <Shimmer width="90%" height={16} rounded={4} sx={{ mb: 0.75 }} />
    <Shimmer width="65%" height={16} rounded={4} sx={{ mb: 1.25 }} />

    {/* Param count · TAT */}
    <Shimmer width="55%" height={11} rounded={4} sx={{ mb: 1.5 }} />

    {/* Price row — main ₹ + strikethrough + save pill */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.25, flexWrap: 'wrap' }}>
      <Shimmer width={90} height={24} rounded={6} />
      <Shimmer width={52} height={11} rounded={4} />
      <Shimmer width={56} height={18} rounded={100} />
    </Box>

    {/* Clock / "Reports in X hrs" row */}
    <Shimmer width="45%" height={11} rounded={4} sx={{ mb: 1.75 }} />

    {/* Parameter bullets (2) */}
    <Shimmer width="80%" height={10} rounded={4} sx={{ mb: 0.75 }} />
    <Shimmer width="65%" height={10} rounded={4} sx={{ mb: 'auto' }} />

    {/* CTA button */}
    <Shimmer width="100%" height={40} rounded={100} sx={{ mt: 2 }} />
  </Box>
);

const PackagesShimmer = ({ count = 8 }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, 1fr)',
        md: 'repeat(3, 1fr)',
        lg: 'repeat(4, 1fr)',
      },
      gap: { xs: 2, md: 2.5 },
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => <PackageCardShimmer key={i} />)}
  </Box>
);

export default PackagesShimmer;
